var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTwinBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15V6c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1H1C.45 0 0 .45 0 1v4c0 .55.45 1 1 1v9c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h1c0 .55.45 1 1 1s1-.45 1-1h4c0 .55.45 1 1 1s1-.45 1-1h1c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1zM9 8h1v7H2V8h7zM3 6V3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V6H3zM1 1.5c0-.28.16-.5.36-.5h9.28c.2 0 .36.22.36.5v3c0 .28-.22.5-.5.5H10V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v2h-.5c-.28 0-.5-.22-.5-.5v-3zm10 16.25c0 .14-.11.25-.25.25h-9.5c-.14 0-.25-.11-.25-.25v-1.5c0-.14.11-.25.25-.25h9.5c.14 0 .25.11.25.25v1.5z",
    fill: "#1ab2c5"
  })));
}

export default SvgIconTwinBed;